import React, { useCallback, useMemo } from 'react';
import checkIcon from '../../../assets/plans/check.svg';
import styles from './SelectorPill.module.css';
import { useProp103Features } from '../../../hooks';

const SelectorPill = ({
  checked = false,
  disabled = false,
  itemExtraData,
  label = '',
  name = '',
  onChange = () => { },
  value = '',
}) => {
  const prop103 = useProp103Features();
  const id = useMemo(() => label.replace(/[^A-Za-z0-9]/g, ''), [label]);

  const handleChange = useCallback(() => {
    onChange({ ...itemExtraData, label, value });
  }, [onChange, itemExtraData, label, value]);

  return (
    <label
      aria-label={`${label} ${name}`}
      aria-live={checked ? 'polite' : 'off'}
      className={`${styles.wrapper} ${prop103 ? styles.wrapperProp103 : ''}`}
      data-checked={checked}
      data-disabled={disabled}
      htmlFor={`${id}-${name}`}
    >
      <input
        aria-disabled={disabled}
        checked={checked}
        className={styles.button}
        id={`${id}-${name}`}
        name={name}
        onChange={handleChange}
        type="radio"
        value={value}
      />

      {checked && <img alt="" className={styles.checkImg} src={checkIcon} />}

      {label}
    </label>
  );
};

export { SelectorPill };
